const DropDown = (props) => {
  const {
    setFilter,
    dataOption,
    placeHolder,
    value,
    hidden,
    style,
    className,
  } = props;

  return (
    <select
      className={className}
      style={style}
      onChange={(e) => setFilter(e.target.value)}
    >
      <option value={value} selected disabled hidden={hidden}>
        {placeHolder}
      </option>
      {dataOption.map((data) => (
        <option value={data.value}>{data.name}</option>
      ))}
    </select>
  );
};
export default DropDown;
